import { handleInsertContent } from './insert-content-handlers';
export var createInsertNodeAPI = function createInsertNodeAPI(analyticsApi) {
  return {
    insert: function insert(_ref) {
      var state = _ref.state,
        dispatch = _ref.dispatch,
        node = _ref.node,
        options = _ref.options;
      if (!state || !dispatch) {
        return false;
      }
      var tr = state.tr;
      handleInsertContent({
        node: node,
        options: options
      })(tr);
      if (options.analyticsPayload) {
        analyticsApi === null || analyticsApi === void 0 ? void 0 : analyticsApi.attachAnalyticsEvent(options.analyticsPayload)(tr);
      }
      dispatch(tr);
      return true;
    }
  };
};